var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('basic-container',[_c('el-form-tabs',{attrs:{"option":_vm.option},on:{"change":_vm.handleChange,"submit":_vm.handleSubmit},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }